<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.6 10c0 5.5-5.7 10.5-7.1 11.6a.8.8 0 0 1-1 0C10.1 20.5 4.4 15.5 4.4 10a7.6 7.6 0 1 1 15.2 0Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="12" cy="10" r="2.5" stroke="currentColor" stroke-width="1.6"/>
</svg>
</template>
